import { Route, Routes, useNavigate } from 'react-router-dom';
import { Welcome } from './pages';
import Layout from 'src/components/Layout/Layout';
import '@weareopenr/component-library/build/global.scss';
import './styles/global.scss';
import { WorkOSAuthProvider } from '@weareopenr/authkit';
import { PostHogErrorBoundary, PostHogProvider } from 'posthog-js/react';
import type { ConfigDefaults } from 'posthog-js';
import { ErrorPage } from './pages/ErrorPage/ErrorPage';
import { HeaderSnackbarProvider } from '@weareopenr/component-library';

declare global {
  interface Window {
    Cypress: Cypress.Cypress;
  }
}

const AppRoutes = () => {
  return (
    <HeaderSnackbarProvider>
      <Routes>
        <Route path="/login" element={<Welcome />} />
        <Route path="/*" element={<Layout />} />
      </Routes>
    </HeaderSnackbarProvider>
  );
};

const ConditionalPostHogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
  const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

  if (!POSTHOG_KEY || !POSTHOG_HOST) {
    return <>{children}</>;
  }

  const options = {
    api_host: POSTHOG_HOST,
    defaults: '2025-05-24' as ConfigDefaults,
  };

  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      <PostHogErrorBoundary fallback={<ErrorPage />}>{children}</PostHogErrorBoundary>
    </PostHogProvider>
  );
};

const App = (): React.ReactElement => {
  const navigate = useNavigate();
  return (
    <ConditionalPostHogProvider>
      <WorkOSAuthProvider
        clientId={process.env.REACT_APP_WORKOS_CLIENT_ID || ''}
        onRedirectCallback={({ state }) => {
          navigate(state?.returnTo || '/', { replace: true });
        }}
      >
        <AppRoutes />
      </WorkOSAuthProvider>
    </ConditionalPostHogProvider>
  );
};

export default App;
